import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './actions';
import selectAllProps from './selectors';
import ProjectManager from '../../components/ProjectManager';
import MyLoader from '../../components/MyLoader';

class ProjectContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
    };
  }

  componentWillMount(){
    this.props.actions.loadProjects();
  }

  componentWillReceiveProps(nextProps) {
  }

  render() {
    if(this.props.loading) return (<MyLoader/>);
    return (
        <div>
          <ProjectManager {...this.props} />
          {this.props.children}
        </div>
    );
  }
}

ProjectContainer.propTypes = {
  projects: PropTypes.array.isRequired,
  actions : PropTypes.object,
  loading: PropTypes.bool,
  children:  PropTypes.node
};

function mapStateToProps(state, ownProps) {
  return selectAllProps(state);
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectContainer);


/** WEBPACK FOOTER **
 ** ./src/container/ProjectContainer/index.js
 **/